<script module lang="ts">
  export const premiumModal = new ModalQueryState('premium');
  export const nudgePremium = async (gamesPlayed: number) => {
    if (gamesPlayed % 3 === 0) {
      await delay(250);
      await premiumModal.push();
    }
  };
</script>

<script lang="ts">
  import Account from '~icons/mdi/account';
  import Close from '~icons/mdi/close';
  import ActionButton from '~/components/ActionButton.svelte';
  import LinkButton from '~/components/LinkButton.svelte';

  import Modal from '~/components/Modal.svelte';
  import Premium from '~/icons/Premium.svelte';
  import { page } from '$app/state';
  import { pendingVerification } from '~/auth/utils.svelte';
  import PremiumOverview from '~/auth/PremiumOverview.svelte';
  import { ModalQueryState } from '~/lib/nav.svelte';
  import { signModal } from '~/auth/Signin.svelte';
  import VerifyEmailButton from '~/components/buttons/VerifyEmailButton.svelte';
  import StatusText from '~/components/StatusText.svelte';
  import JumpButton from '~/components/buttons/JumpButton.svelte';
  import { isPremium } from '~/lib/queries.svelte';
  import ManageSubscription from '~/auth/ManageSubscription.svelte';
  import SubscribeCard from '~/auth/SubscribeCard.svelte';
  import { tick } from 'svelte';
  import { goto } from '$app/navigation';
  import { delay } from '~/animations/utils.svelte';

  const premium = isPremium();
  let scrollHeight = $state(0);

  const handleClose = async () => {
    // if user is trying to access archive puzzle but don't have premium
    // TODO
    if (!premium.data && page.url.searchParams.has('date')) {
      // page.url is readonly in SvelteKit 3, so edit a copy
      const url = new URL(page.url.href);
      url.searchParams.delete('date');
      url.searchParams.delete('premium');
      await goto(url.pathname + url.search);
    } else {
      await premiumModal.pop();
    }
  };

  const handleSignin = () => {
    signModal.push('in');
  };

  const handleSignup = () => {
    signModal.push('up');
  };
</script>

<svelte:head>
  <script async src="https://js.stripe.com/v3/buy-button.js">
  </script>
</svelte:head>
<Modal index={5} open={premiumModal.open} onClose={handleClose}>
  {#snippet title()}
    <div class="title">
      <Premium size="2.5em" />
      Gram Jam Premium
    </div>
  {/snippet}
  {#snippet content({ scrollTo, scrollOffset, contentHeight })}
    <div class="content" bind:clientHeight={scrollHeight}>
      {#if !page.data.user}
        {#if pendingVerification.current}
          <StatusText status="warn">
            Verify your email
            <VerifyEmailButton />
          </StatusText>
        {:else}
          <JumpButton
            {scrollOffset}
            scrollThreshold={50}
            onClick={handleSignin}
          >
            <Account size="1.5em" />
            LOG IN
          </JumpButton>
          <LinkButton onClick={handleSignin}>
            already have an account?
            <Account /> Log in
          </LinkButton>
        {/if}
      {:else if !premium.data}
        <JumpButton
          bottom
          {scrollOffset}
          scrollThreshold={scrollHeight - (contentHeight ?? 0) - 240}
          onClick={() => scrollTo(99999)}
        >
          <Account size="1.5em" />
          Subscribe
        </JumpButton>
      {:else}
        <StatusText status="success">You are a Premium member!</StatusText>
      {/if}
      <PremiumOverview hideSupport={premium.data} />
      {#if premium.data}
        <ManageSubscription />
      {:else if premiumModal.open}
        <SubscribeCard />
      {/if}
    </div>
  {/snippet}
  {#snippet controls()}
    <div class="controls-container">
      <div class="controls">
        <ActionButton onClick={handleClose}>
          <Close />
          Close
        </ActionButton>
        {#if page.data.user}
          <!--
        <ActionButton href="#premium" outlink={false}>
          <Premium />
          Get premium
        </ActionButton>
        -->
        {:else}
          <ActionButton onClick={handleSignup}>
            <Account />
            Create account
          </ActionButton>
        {/if}
      </div>
    </div>
  {/snippet}
</Modal>

<style lang="scss">
  @use '~/theme/theme';
  .title {
    display: grid;
    grid-auto-flow: column;
    gap: 0.5em;
    font-weight: bold;
    align-items: center;
    justify-content: center;
    text-align: left;
    margin: -0.25em 0;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .controls-container {
    display: flex;
    flex-direction: column;
  }
  .controls {
    display: flex;
    flex-direction: row;
    gap: 0.5em;
  }
</style>
